import React, { useEffect, useState } from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';

function Navigation({ setPage, navigateToAnchor }) {
    const location = useLocation();
    const onLLMesh = location.pathname === '/llmesh';
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 40);
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    const goAnchor = (e, anchor) => {
        e.preventDefault();
        if (navigateToAnchor) navigateToAnchor(anchor);
    };
    return (
        <Navbar expand="lg" className={`navbar-dark site-nav${scrolled ? ' site-nav-scrolled' : ''}`}>
            <Container>
                <Navbar.Brand as={Link} to="/" onClick={() => setPage('home')} className="d-flex align-items-center gap-2">
                    <img
                        src="/qcoda_icon_white.png"
                        alt="Qcoda — Governed AI Orchestration"
                        height="36"
                        className="d-inline-block align-top rounded"
                    />
                    <span className="fw-bold text-white fs-4">QCoda</span>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto align-items-lg-center">
                        {/* Anchor links use real href="/#why" so crawlers see meaningful URLs;
                            onClick intercepts to do smooth scroll / router state when JS is on. */}
                        <Nav.Link href="/#why" onClick={(e) => goAnchor(e, 'why')} className="text-white fw-medium">Why Qcoda</Nav.Link>
                        <Nav.Link as={Link} to="/solutions" className="text-white fw-medium">Solutions</Nav.Link>
                        <Nav.Link href="/#industries" onClick={(e) => goAnchor(e, 'industries')} className="text-white fw-medium">Industries</Nav.Link>
                        <Nav.Link href="/#enterprise" onClick={(e) => goAnchor(e, 'enterprise')} className="text-white fw-medium">Enterprise</Nav.Link>
                        <Nav.Link as={Link} to="/blog" className="text-white fw-medium">Blog</Nav.Link>
                        <Nav.Link as={Link} to="/company/press" className="text-white fw-medium">Press</Nav.Link>
                        <Nav.Link
                            as={Link}
                            to="/llmesh"
                            className="fw-medium d-flex align-items-center gap-1"
                            style={{ color: onLLMesh ? '#f5c518' : 'rgba(245,197,24,0.75)', transition: 'color 0.15s ease' }}
                        >
                            <img src="/llmesh_logo.png" alt="" style={{ width: '18px', height: '18px', objectFit: 'contain' }} />
                            LLMesh
                        </Nav.Link>
                        <Nav.Link as={Link} to="/contact" className="text-white fw-medium">Contact</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default Navigation;
